exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".st-dropdown[data-v-59666a60]{position:relative;overflow:hidden;transition:.2s ease-out;display:block!important;grid-column:1/-1}.st-dropdown[data-v-59666a60]:not(.active){height:0;padding-top:0;padding-bottom:0;border:0;opacity:0}.st-dropdown.active[data-v-59666a60]{height:auto;padding:1rem}", ""]);

// exports
